<template>
	<BaseCmsPage v-slot="{page}">
		<AuthMainLayout>
			<template #authContent>
				<h1>{{ page?.seo_h1 }}</h1>
				<div class="auth-change-password-inner">
					<BaseCmsLabel tag="h2" class="auth-change-password-subtitle" code="change_password_subtitle" />
					<BaseAuthChangePasswordForm v-slot="{fields, status, loading}" class="form-animated-label form-change-password">
						<div v-if="status && status?.success" class="global-success"><BaseCmsLabel :code="status.data?.label_name" /></div>

						<template v-if="!status?.success">
							<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
								<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}]">
									<BaseFormInput />
									<BaseCmsLabel v-if="item.name == 'password'" tag="label" for="password" code="desired_password" />
									<BaseCmsLabel v-else tag="label" :for="item.name" :code="item.name" />
									<span class="error" v-show="errorMessage" v-html="errorMessage" />
								</p>
							</BaseFormField>
							<button type="submit" :class="{'loading': loading}"><UiLoader v-if="loading" size="small" /><BaseCmsLabel code="save_new_password" /></button>
						</template>
					</BaseAuthChangePasswordForm>
				</div>
			</template>
		</AuthMainLayout>
	</BaseCmsPage>
</template>

<script setup></script>

<style lang="less" scoped>
	@media (min-width: @m){	
		.auth-change-password-inner{padding: 36px 40px 40px; background: #fff; border-radius: 8px; box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);}
	}
	.auth-change-password-subtitle{
		font-size: 20px; padding-bottom: 16px;
		@media (max-width: @m){font-size: 18px; padding-bottom: 12px;}	
	}
	:deep(.form-change-password){
		max-width: 340px;
		@media (max-width: @m){max-width: 100%;}	
	}
	button{
		margin-top: 12px;
		@media (max-width: @m){margin-top: 10px;}	
	}
</style>
